import React from 'react';
import { FieldError } from 'react-hook-form';
import styled from 'styled-components';

import { UiTypography } from '@/components/ui/Typography';

const EmailInputStyle = styled.input`
  margin: 16px 0 0;
  padding: 8px 20px;
  border: none;
  border-radius: 30px;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0);
  width: 100%;
  color: #fff;
  color: var(--Default-Dark-Label-Primary, #fff);
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.5px;

  &::placeholder {
    color: #c7c7c7;
  }

  &:focus {
    outline: none;
  }
`;

export const EmailInput = React.forwardRef<
  HTMLInputElement,
  React.DetailedHTMLProps<
    React.InputHTMLAttributes<HTMLInputElement>,
    HTMLInputElement
  > & {
    error: FieldError | undefined;
  }
>(function EmailInput(props, ref) {
  const errorMessage = props.error?.message;

  return (
    <>
      <EmailInputStyle {...props} ref={ref} />
      {errorMessage && (
        <UiTypography variant="body-small" color="danger">
          {errorMessage}
        </UiTypography>
      )}
    </>
  );
});
